const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES',
  'SE', 'GB', 'UK', 'IS', 'LI', 'NO', 'CH',
];

function isLocalDev() {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

async function detectEuRegion() {
  if (isLocalDev()) return false;

  try {
    const response = await fetch('/cdn-cgi/trace');
    if (!response.ok) throw new Error('Cloudflare trace unavailable');

    const text = await response.text();
    const match = text.match(/^loc=([A-Z]{2})$/m);
    if (!match) throw new Error('Country code missing from Cloudflare trace');

    return EU_COUNTRIES.includes(match[1]);
  } catch (_error) {
    // Fail closed for compliance when region cannot be determined.
    return true;
  }
}

module.exports = { EU_COUNTRIES, isLocalDev, detectEuRegion };
